module.exports = __webpack_public_path__ + "static/img/synthe3.4948c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/synthe3.png
// module id = L42C
// module chunks = 2